import { useEffect, useRef, useState, useCallback } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { api } from "../api"; // <-- sua instância axios (com token)
import "bootstrap/dist/css/bootstrap.min.css";
import { kml } from "@tmcw/togeojson";

export default function AdminCTO({ onLogout, role }) {
  const isReadOnly = role === "viewer";                  // ← derivar flag
  const mapContainer = useRef(null);
  const mapRef = useRef(null);

  const tempPointRef = useRef(null);
  const ctoLayerRef = useRef(null);
  const vehiclesLayerRef = useRef(null);

  const [ctos, setCtos] = useState([]);
  const [selectedCoord, setSelectedCoord] = useState(null);

  const [tempName, setTempName] = useState("");
  const [tempSignal, setTempSignal] = useState("");
  const [tempLotacao, setTempLotacao] = useState("");
  const [tempSplitter, setTempSplitter] = useState("");
  const [tempOlt, setTempOlt] = useState("");
  const [tempIdOlt, setTempIdOlt] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null); // CTO selecionada
  const [clientes, setClientes] = useState([]); // lista de clientes da CTO
  const [newClienteName, setNewClienteName] = useState("");
  const [newClienteSignal, setNewClienteSignal] = useState("");
  const [newClienteLoginId, setNewClienteLoginId] = useState("");
  const [newClienteMac, setNewClienteMac] = useState("");
  const [newClienteIdOnt, setNewClienteIdOnt] = useState("");
  const [newClientePlacaPon, setNewClientePlacaPon] = useState("");

  const [baseLayerKey, setBaseLayerKey] = useState("osm"); // osm | satellite | outdoors

  const [searchCTO, setSearchCTO] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const [coordInput, setCoordInput] = useState("");

  const vehicleMarkersRef = useRef({});
  const vehicleMotionRef = useRef({});
  const vehicleLastUpdateRef = useRef({});

  const [newPlaca, setNewPlaca] = useState("");
  const [newCondutor, setNewCondutor] = useState("");
  const [legend, setLegend] = useState([]);
  const [legendCollapsed, setLegendCollapsed] = useState(false);

  const vehicleAddressRef = useRef({});

  // Carregar condutores do banco ao iniciar
  const loadLegend = useCallback(async () => {
    try {
      const res = await api.get("/condutores/list");
      setLegend(res.data); // [{id, placa, condutor}]
    } catch (err) {
      console.error("Erro ao carregar condutores:", err);
    }
  }, []);

  // tile layers (OpenStreetMap padrão e alternativas)
  const tileLayers = {
    osm: L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19,
      attribution: "&copy; OpenStreetMap contributors",
    }),
    satellite: L.tileLayer(
      "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
      { maxZoom: 19, attribution: "Esri" }
    ),
    outdoors: L.tileLayer("https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png", {
      maxZoom: 17,
      attribution: "OpenTopoMap",
    }),
  };

  // Função que cria um ícone quadrado para CTO
  function ctoSquareIcon(signal) {
    const color =
      signal == null || signal === 0
        ? "#FF0000"
        : signal >= -26
        ? "#00CC00"
        : signal > -32
        ? "#FFA500"
        : "#FF0000";

    return L.divIcon({
      html: `
        <div style="
          width: 20px;
          height: 20px;
          background-color: ${color};
          border: 3px solid #000;
          box-sizing: border-box;
        "></div>
      `,
      className: "",
      iconSize: [20, 20],
      iconAnchor: [10, 10], // centraliza o quadrado no ponto
    });
  }

  // Cria o divIcon do veículo com placa e círculo de ignição
  function vehicleDivIcon(licensePlate, ignitionOn, heading) {
    const correctedHeading = heading - 90; // COMPENSAÇÃO DO ÍCONE
    return L.divIcon({
      html: `
        <div style="display:flex;flex-direction:column;align-items:center;white-space:nowrap;">

          <!-- Placa -->
          <div style="
            background:rgba(0,0,0,1);
            color:#fff;
            padding:4px 10px;
            border-radius:6px;
            margin-bottom:4px;
            font-weight:bold;
            min-width:70px;
            text-align:center;
            font-size:14px;
            line-height:1.2;
          ">
            ${licensePlate}
          </div>

          <!-- Carro rotacionável -->
          <div style="position:relative; display:flex; align-items:center; justify-content:center;">

            <!-- Círculo de ignição -->
            <div style="
              width:14px;
              height:14px;
              border-radius:50%;
              background:${ignitionOn ? '#00ff00' : '#df4b45ff'};
              position:absolute;
              top:-25px;
              right:-25px;
              border:1px solid ${ignitionOn ? '#006600' : 'transparent'};
            "></div>

            <!-- Carro (rotaciona pela heading) -->
            <div style="
              transform: rotate(${correctedHeading}deg);
              transition: transform 0.3s linear;
            ">
              <img src="/icons/carnew.png" style="width:52px;height:52px;"/>
            </div>
          </div>
        </div>
      `,
      className: "vehicle-div-icon",
      iconSize: [60, 70],
      iconAnchor: [30, 35],
    });
  }

  //----------------------Função para converter coordenadas (DMS → decimal)----------

  function parseDMS(input) {
    try {
      const regex = /(\d+)[°\s]+(\d+)'(\d+(?:\.\d+)?)"?([NS])\s+(\d+)[°\s]+(\d+)'(\d+(?:\.\d+)?)"?([EW])/i;
      const match = input.match(regex);

      if (!match) return null;

      let lat = (+match[1]) + (+match[2] / 60) + (+match[3] / 3600);
      let lon = (+match[5]) + (+match[6] / 60) + (+match[7] / 3600);

      if (match[4].toUpperCase() === "S") lat *= -1;
      if (match[8].toUpperCase() === "W") lon *= -1;

      return { lat, lon };
    } catch {
      return null;
    }
  }
  //----------------------Função para ir coordenadas ----------

  const handleGoToCoord = () => {
    if (!coordInput) return;

    let lat, lon;

    // tenta formato decimal primeiro (ex: -12.56, -38.12)
    if (coordInput.includes(",")) {
      const parts = coordInput.split(",");
      lat = parseFloat(parts[0]);
      lon = parseFloat(parts[1]);
    } else {
      // tenta formato DMS
      const parsed = parseDMS(coordInput);
      if (!parsed) {
        alert("Formato inválido de coordenada");
        return;
      }
      lat = parsed.lat;
      lon = parsed.lon;
    }

    if (isNaN(lat) || isNaN(lon)) {
      alert("Coordenadas inválidas");
      return;
    }

    mapRef.current.setView([lat, lon], 18, {
      animate: true,
      duration: 1.5,
    });

    // marcador temporário
    if (tempPointRef.current) {
      tempPointRef.current.setLatLng([lat, lon]);
    } else {
      tempPointRef.current = L.marker([lat, lon]).addTo(mapRef.current);
    }
  };


  //-----------------------------------------------------------
  // ------------------- Inicialização do mapa -------------------
  useEffect(() => {
    if (mapRef.current) return;

    mapRef.current = L.map(mapContainer.current, {
      center: [-12.769313, -38.182554],
      zoom: 15,
      layers: [tileLayers[baseLayerKey]],
    });

    // adicionar controle de camadas (opcional visual)
    const baseMaps = {
      "OSM (Padrão)": tileLayers.osm,
      "Satélite (ESRI)": tileLayers.satellite,
      "Outdoors (Topo)": tileLayers.outdoors,
    };
    L.control.layers(baseMaps, {}).addTo(mapRef.current);

    // evento click no mapa -> ponto temporário para cadastrar CTO
    mapRef.current.on("click", (e) => {
      if (isReadOnly) return;  // ← NOVO: bloqueia cadastro
      const { lat, lng } = e.latlng;
      setSelectedCoord({ lat, lon: lng });

      // desenha/atualiza marcador temporário
      if (tempPointRef.current) {
        tempPointRef.current.setLatLng([lat, lng]);
      } else {
        tempPointRef.current = L.marker([lat, lng], {
          icon: L.divIcon({
            html: `
              <svg width="36" height="36" viewBox="0 0 24 24">
                <path fill="#1A73E8" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
                <circle cx="12" cy="9" r="3" fill="white"/>
              </svg>
            `,
            className: "",
            iconSize: [36, 36],
            iconAnchor: [18, 36],
          }),
        }).addTo(mapRef.current);
      }
    });

    // cria camadas 
    ctoLayerRef.current = L.geoJSON(null, {
    pointToLayer: (feature, latlng) => {
      return L.marker(latlng, {
        icon: ctoSquareIcon(feature.properties.signal),
        zIndexOffset: 0,
      });
    },
    onEachFeature: (feature, layer) => {
      layer.on("mouseover", (e) => {
        const props = feature.properties || {};
        const popupContent = `
          <strong>${props.name}</strong><br/>
          Sinal médio: ${props.signal === 0 ? "LOS" : (props.signal ?? "LOS")}<br/>
          Lotação: ${props.lotacao ?? "–"}<br/>
          Splitter: ${props.splitter ?? "–"}
        `;
        layer.bindPopup(popupContent, { offset: [0, -10], closeButton: false }).openPopup();
      });
      layer.on("mouseout", (e) => {
        layer.closePopup();
      });

      layer.on("click", async (e) => {
        const props = feature.properties;
        const [lon, lat] = feature.geometry.coordinates;
        setEditData({
          id: props.id,
          name: props.name,
          signal: props.signal,
          lotacao: props.lotacao,
          splitter: props.splitter,
          olt: props.olt,
          id_olt: props.id_olt,
          lat,
          lon,
        });
        await loadClientes(props.id);
        if (!isReadOnly) setShowModal(true);
      });
    },
  }).addTo(mapRef.current);

    vehiclesLayerRef.current = L.layerGroup().addTo(mapRef.current);

    // inicializa dados
    loadCTOs();
    loadVehicles();
    loadLegend();

    // timers
    const vehiclesInterval = setInterval(loadVehicles, 10000); // 30s
    const ctosInterval = setInterval(loadCTOs, 30000); // 30s

    return () => {
      clearInterval(vehiclesInterval);
      clearInterval(ctosInterval);
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ------------------- trocar camada base quando baseLayerKey muda -------------------
  useEffect(() => {
    if (!mapRef.current) return;
    // remove todas as tile layers e adiciona a escolhida
    Object.values(tileLayers).forEach((t) => {
      try {
        mapRef.current.removeLayer(t);
      } catch (e) {}
    });
    tileLayers[baseLayerKey].addTo(mapRef.current);
  }, [baseLayerKey]);

  // ------------------- carregar CTOs -------------------
  const loadCTOs = useCallback(async () => {
    try {
      const res = await api.get("/cto/list");
      setCtos(res.data);

      // Converte para GeoJSON FeatureCollection
      const features = res.data.map((cto) => ({
        type: "Feature",
        geometry: JSON.parse(cto.location),
        properties: {
          id: cto.id,
          name: cto.nome,
          signal: cto.sinal != null ? Number(cto.sinal) : null,
          lotacao: cto.lotacao,
          splitter: cto.splitter,
          olt: cto.olt,
          id_olt: cto.id_olt,
        },
      }));

      // atualiza camada
      ctoLayerRef.current.clearLayers();
      ctoLayerRef.current.addData({ type: "FeatureCollection", features });
    } catch (err) {
      console.error("Erro loadCTOs:", err);
    }
  }, []);


  //-------------------------------------
  const handleSearch = (value) => {

    setSearchCTO(value);

    if (!value) {
      setSearchResults([]);
      return;
    }

    const results = ctos.filter(cto =>
      cto.nome.toLowerCase().includes(value.toLowerCase())
    );

    setSearchResults(results.slice(0, 10)); // limite 10 resultados
  };

  const flyToCTO = (cto) => {

    const geo = JSON.parse(cto.location);
    const [lon, lat] = geo.coordinates;

    mapRef.current.setView([lat, lon], 18, {
      animate: true,
      duration: 1.5
    });

    setSearchResults([]);
    setSearchCTO("");

  };

  //-------------------------------------


  const importCTOsFromGeoJSON = async (geojson) => {

    for (const feature of geojson.features) {

      if (!feature.geometry) continue;

      if (feature.geometry.type === "Point") {

        const [lon, lat] = feature.geometry.coordinates;

        const nome = feature.properties.name || "CTO Importada";

        await api.post("/cto/add", {
          nome,
          lat,
          lon
        });

      }

      if (feature.geometry.type === "MultiPoint") {

        for (const coord of feature.geometry.coordinates) {

          const [lon, lat] = coord;

          const nome = feature.properties.name || "CTO Importada";

          await api.post("/cto/add", {
            nome,
            lat,
            lon
          });

        }

      }

    }

    alert("CTOs importadas!");
    loadCTOs();

  };

  const handleKMZUpload = async (event) => {
  const file = event.target.files[0];
  if (!file) return;

  const reader = new FileReader();

  reader.onload = async (e) => {
    try {
      let text;

      if (file.name.toLowerCase().endsWith(".kmz")) {
        // KMZ = zip binário → precisa de ArrayBuffer
        const JSZip = (await import("jszip")).default;
        const zip = await JSZip.loadAsync(e.target.result); // ArrayBuffer

        const kmlFile = Object.values(zip.files).find(
          (f) => f.name.toLowerCase().endsWith(".kml")
        );

        if (!kmlFile) {
          alert("Nenhum arquivo .kml encontrado dentro do KMZ.");
          return;
        }

        text = await kmlFile.async("text");

      } else {
        // KML = texto direto
        text = e.target.result; // já é string porque usamos readAsText
      }

      const parser = new DOMParser();
      const xml = parser.parseFromString(text, "text/xml");

      // Verifica se o XML parseou com erro
      const parseError = xml.querySelector("parsererror");
      if (parseError) {
        alert("Erro ao interpretar o arquivo KML. Verifique se está correto.");
        console.error(parseError.textContent);
        return;
      }

      const geojson = kml(xml);
      console.log("GeoJSON gerado:", geojson); // útil para debug

      if (!geojson.features || geojson.features.length === 0) {
        alert("Nenhum ponto encontrado no arquivo.");
        return;
      }

      await importCTOsFromGeoJSON(geojson);

    } catch (err) {
      console.error("Erro ao processar arquivo:", err);
      alert("Erro ao processar o arquivo: " + err.message);
    }
  };

  // KMZ → binário | KML → texto
  if (file.name.toLowerCase().endsWith(".kmz")) {
    reader.readAsArrayBuffer(file);
  } else {
    reader.readAsText(file); // ← esse era o bug para .kml
  }
};


  
  //-------------------------------------

  // ------------------- carregar veículos (Cobli + JIMI) -------------------
  
  // Funções preve movimento
  function moveByHeading(lat, lng, speedKmh, headingDeg, deltaTimeSec) {
    const R = 6378137;

    const speed = speedKmh || 0;
    // 0.5 reduz a projeção de distancia para 50%
    const distance = (speed * 1000 / 3600) * deltaTimeSec * 0.5; 

    const headingRad = headingDeg * Math.PI / 180;

    const newLat =
      lat + (distance * Math.cos(headingRad)) / R * (180 / Math.PI);

    const newLng =
      lng +
      (distance * Math.sin(headingRad)) /
        (R * Math.cos(lat * Math.PI / 180)) *
        (180 / Math.PI);

    return [newLat, newLng];
  }

  //Funções de movimento
  function startVehicleMotion(id, marker, vehicle) {
  // já existe loop → atualiza dados e posição base
  if (vehicleMotionRef.current[id]) {
    const motion = vehicleMotionRef.current[id];
    motion.vehicle = vehicle;

    // 🔥 atualiza base real
    motion.baseLat = vehicle.latitude;
    motion.baseLng = vehicle.longitude;

    return;
  }

  let lastTime = performance.now();

  const motionObj = {
    vehicle,
    running: true,

    // 🔥 posição base REAL (vinda da API)
    baseLat: vehicle.latitude,
    baseLng: vehicle.longitude
  };

  vehicleMotionRef.current[id] = motionObj;

  function step(now) {
    if (!motionObj.running) return;

    const delta = (now - lastTime) / 1000;
    lastTime = now;

    const v = motionObj.vehicle;

    const speed = v.ignitionOn ? v.speed : 0;

    // 🔥 usa SEMPRE a base real + evolução
    const [newLat, newLng] = moveByHeading(
      motionObj.baseLat,
      motionObj.baseLng,
      speed,
      v.heading || 0,
      delta
    );

    // 🔥 atualiza base continuamente (movimento fluido)
    motionObj.baseLat = newLat;
    motionObj.baseLng = newLng;

    marker.setLatLng([newLat, newLng]);

    requestAnimationFrame(step);
  }

  requestAnimationFrame(step);
}

  function smoothCorrection(marker, lat, lng) {
    const current = marker.getLatLng();

    const distance =
      Math.sqrt(
        Math.pow(current.lat - lat, 2) +
        Math.pow(current.lng - lng, 2)
      );

    // 🔥 se for muito longe → teleporte (evita puxar pra trás)
    if (distance > 0.001) {
      marker.setLatLng([lat, lng]);
      return;
    }

    // 🔥 suaviza só se for perto
    const newLat = current.lat + (lat - current.lat) * 0.2;
    const newLng = current.lng + (lng - current.lng) * 0.2;

    marker.setLatLng([newLat, newLng]);
  }


async function reverseGeocode(lat, lng) {
  try {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json&addressdetails=1`,
      { headers: { "Accept-Language": "pt-BR" } }
    );
    const data = await res.json();

    const a = data.address || {};

    const rua      = a.road || a.pedestrian || a.path || "";
    const numero   = a.house_number || "";
    const bairro   = a.suburb || a.neighbourhood || a.quarter || "";
    const cidade   = a.village || a.town || a.city || "";
    const estado   = a.state || "";
    const cep      = a.postcode || "";

    return {
      completo: data.display_name,
      rua:      numero ? `${rua}, ${numero}` : rua,
      bairro,
      cidade,
      estado,
      cep,
    };
  } catch (err) {
    console.error("Erro reverse geocode:", err);
    return null;
  }
} 

function getVehiclePopup(v) {
  const addr = vehicleAddressRef.current[v.id];

  const enderecoHtml = addr
    ? `
        <b>Endereço:</b> ${addr.completo}<br/>
      `
    : `<span style="color:#aaa;font-size:12px;">Carregando endereço...</span>`;

  return `
    <div style="font-size:14px; min-width: 200px;">
      <b>Placa:</b> ${v.licensePlate}<br/>
      <b>Motorista:</b> ${v.driverName}<br/>
      <b>Velocidade:</b> ${v.speed} km/h<br/>
      <b>Ignição:</b> ${v.ignitionOn ? "🟢 Ligada" : "🔴 Desligada"}<br/>
      <hr style="margin:6px 0"/>
      ${enderecoHtml}
    </div>
  `;
}
// GET VEICULOS 
const loadVehicles = useCallback(async () => {
  try {
    const res = await api.get("/cobli/vehicles");

    const vehicles = res.data.filter(
      (v) => v.latitude && v.longitude && v.licensePlate !== "N/A"
    );

    vehicles.forEach((v) => {
      const id = v.id;
      const now = Date.now();

      if (!vehicleLastUpdateRef.current[v.id]) {
        vehicleLastUpdateRef.current[v.id] = now;
      }

      // 🔥 IGNORA atualização atrasada
      if (now < vehicleLastUpdateRef.current[v.id]) {
        return;
      }

      vehicleLastUpdateRef.current[v.id] = now;

      let marker = vehicleMarkersRef.current[id];

      if (marker) {
        // 🔄 Correção suave (evita teleporte)
        if (!v.ignitionOn || v.speed < 3) {
          smoothCorrection(marker, v.latitude, v.longitude);
        }

        // 🔄 Atualiza ícone (rotação / ignição)
        marker.setIcon(
          vehicleDivIcon(v.licensePlate, v.ignitionOn, v.heading)
        );

        // ✅ ATUALIZA POPUP DINAMICAMENTE
        if (marker.isPopupOpen()) {
          marker.setPopupContent(getVehiclePopup(v));
        }

        // 🔄 Atualiza movimento
        startVehicleMotion(id, marker, v);

      } else {
        // 🆕 Novo veículo
        marker = L.marker([v.latitude, v.longitude], {
          icon: vehicleDivIcon(v.licensePlate, v.ignitionOn, v.heading),
          zIndexOffset: 1000,
        });

        // ✅ USANDO FUNÇÃO
        marker.bindPopup(getVehiclePopup(v));

        // ← NOVO: busca endereço ao abrir o popup
        marker.on("popupopen", async () => {
          // só busca se não tiver endereço ainda ou se o carro se moveu muito
          const cached = vehicleAddressRef.current[v.id];
          const current = marker.getLatLng();

          const shouldFetch = !cached || (
            Math.abs(cached._lat - current.lat) > 0.001 ||
            Math.abs(cached._lng - current.lng) > 0.001
          );

          if (shouldFetch) {
            const addr = await reverseGeocode(current.lat, current.lng);
            if (addr) {
              vehicleAddressRef.current[v.id] = {
                ...addr,
                _lat: current.lat, // guarda posição do último fetch
                _lng: current.lng,
              };
              // atualiza o popup com o endereço real
              marker.setPopupContent(getVehiclePopup(v));
            }
          }
        });

        marker.addTo(vehiclesLayerRef.current);

        vehicleMarkersRef.current[id] = marker;

        // 🚀 inicia movimento contínuo
        startVehicleMotion(id, marker, v);
      }
    });

    // 🧹 remover veículos que sumiram
    Object.keys(vehicleMarkersRef.current).forEach((id) => {
      if (!vehicles.find((v) => v.id === id)) {
        const marker = vehicleMarkersRef.current[id];

        vehiclesLayerRef.current.removeLayer(marker);

        if (vehicleMotionRef.current[id]) {
          vehicleMotionRef.current[id].running = false;
          delete vehicleMotionRef.current[id];
        }

        delete vehicleMarkersRef.current[id];
      }
    });

  } catch (err) {
    console.error("Erro ao carregar veículos:", err);
  }
}, []);

  // ------------------- CRUD CTO -------------------
  const saveCTO = async () => {
    if (!selectedCoord || !tempName) {
      alert("Clique no mapa e informe os campos obrigatórios.");
      return;
    }

    const { lat, lon } = selectedCoord;

    try {
      await api.post("/cto/add", {
        nome: tempName,
        lat,
        lon,
        sinal: tempSignal !== "" ? parseFloat(tempSignal) : null,
        lotacao: tempLotacao !== "" ? parseInt(tempLotacao) : null,
        splitter: tempSplitter !== "" ? parseInt(tempSplitter) : null,
        olt: tempOlt || null,
        id_olt: tempIdOlt !== "" ? parseInt(tempIdOlt) : null,
      });

      setTempName("");
      setTempSignal("");
      setTempLotacao("");
      setTempSplitter("");
      setTempOlt("");
      setTempIdOlt("");
      setSelectedCoord(null);

      if (tempPointRef.current) {
        mapRef.current.removeLayer(tempPointRef.current);
        tempPointRef.current = null;
      }

      await loadCTOs();
      alert("CTO cadastrada!");
    } catch (err) {
      console.error("Erro salvar CTO:", err);
      alert("Erro ao cadastrar CTO.");
    }
  };

  const updateCTO = async () => {
    try {
      await api.put(`/cto/update/${editData.id}`, {
        nome: editData.name,
        sinal: editData.signal !== "" ? parseFloat(editData.signal) : null,
        lotacao: editData.lotacao !== "" ? parseInt(editData.lotacao) : null,
        splitter: editData.splitter !== "" ? parseInt(editData.splitter) : null,
        lat: editData.lat,
        lon: editData.lon,
        olt: editData.olt || null,
        id_olt: editData.id_olt !== "" ? parseInt(editData.id_olt) : null,
      });
      setShowModal(false);
      await loadCTOs();
    } catch (err) {
      console.error("Erro updateCTO:", err);
      alert("Erro ao atualizar CTO.");
    }
  };

  const deleteCTO = async () => {
    try {
      await api.delete(`/cto/delete/${editData.id}`);
      setShowModal(false);
      await loadCTOs();
    } catch (err) {
      console.error("Erro deleteCTO:", err);
      alert("Erro ao excluir CTO.");
    }
  };

  // ------------------- Clientes -------------------
  const loadClientes = async (ctoId) => {
    try {
      const res = await api.get(`/clientes/cto/${ctoId}`);
      setClientes(res.data);
    } catch (err) {
      console.error("Erro loadClientes:", err);
      setClientes([]);
    }
  };

  const addCliente = async () => {
    if (!newClienteName) return alert("Informe o nome do cliente.");
    try {
      await api.post("/clientes/add", {
        nome: newClienteName,
        sinal: newClienteSignal ? parseFloat(newClienteSignal) : null,
        login_id:
          newClienteLoginId !== "" ? parseInt(newClienteLoginId) : null,
        mac: newClienteMac || null,
        id_ont:
          newClienteIdOnt !== "" ? parseInt(newClienteIdOnt) : null,
        placa_pon: newClientePlacaPon || null,
        cto_id: editData.id,
      });

      setNewClienteName("");
      setNewClienteSignal("");
      setNewClienteLoginId("");
      await loadClientes(editData.id);
    } catch (err) {
      console.error("Erro addCliente:", err);
      if (err.response?.data?.error === "LOGIN_ID_DUPLICADO") {
        alert("Este login_id já está vinculado a outro cliente!");
        return;
      }
      alert("Erro ao adicionar cliente.");
    }
  };

  const updateCliente = async (cliente) => {
    try {
      await api.put(`/clientes/update/${cliente.id}`, {
        nome: cliente.nome,
        sinal: cliente.sinal ? parseFloat(cliente.sinal) : null,
        login_id: cliente.login_id !== "" ? parseInt(cliente.login_id) : null,
        mac: cliente.mac || null,
        id_ont: cliente.id_ont !== "" ? parseInt(cliente.id_ont) : null,
        placa_pon: cliente.placa_pon || null,
      });

      await loadClientes(editData.id);
    } catch (err) {
      console.error("Erro updateCliente:", err);
      if (err.response?.data?.error === "LOGIN_ID_DUPLICADO") {
        alert("Este login_id já está vinculado a outro cliente!");
        return;
      }
      alert("Erro ao atualizar cliente.");
    }
  };

  const deleteCliente = async (clienteId) => {
    try {
      await api.delete(`/clientes/delete/${clienteId}`);
      await loadClientes(editData.id);
    } catch (err) {
      console.error("Erro deleteCliente:", err);
      alert("Erro ao excluir cliente.");
    }
  };

  // FECHAR MODAL ESC
  useEffect(() => {
    if (!showModal) return;
    const handleKeyDown = (e) => {
      if (e.key === "Escape") setShowModal(false);
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [showModal]);


  // -------------------LEGENDA CONDUTORES ---------------
  // Adicionar condutor
  const addLegendItem = async () => {
    if (!newPlaca && !newCondutor) return; // evita salvar linha vazia
    try {
      const res = await api.post("/condutores/add", {
        placa: newPlaca,
        condutor: newCondutor,
      });
      setLegend([...legend, res.data.condutor]);
      setNewPlaca("");
      setNewCondutor("");
    } catch (err) {
      console.error("Erro ao adicionar condutor:", err);
    }
  };

  // Atualizar campo localmente (digitando)
  const updateLegendItem = (index, field, value) => {
    const updated = [...legend];
    updated[index][field] = value;
    setLegend(updated);
  };

  // Salvar no banco ao sair do campo (onBlur)
  const saveLegendItem = async (index) => {
    const item = legend[index];
    if (!item.id) return;
    try {
      await api.put(`/condutores/update/${item.id}`, {
        placa: item.placa,
        condutor: item.condutor,
      });
    } catch (err) {
      console.error("Erro ao salvar condutor:", err);
    }
  };

  // Remover condutor
  const removeLegendItem = async (index) => {
    const item = legend[index];
    try {
      if (item.id) {
        await api.delete(`/condutores/delete/${item.id}`);
      }
      setLegend(legend.filter((_, i) => i !== index));
    } catch (err) {
      console.error("Erro ao remover condutor:", err);
    }
};

  // ------------------- JSX (interface igual ao seu Mapbox) -------------------
  return (
    <div style={{ padding: "0px" }}>
      <nav className="navbar navbar-dark bg-dark mb-1 d-flex justify-content-center gap-3">
        <span className="navbar-brand m-0 fs-5 text-center">IClickMap - CTOs</span>
        <button className="btn btn-danger" onClick={onLogout}>
          Sair
        </button>
      </nav>

      <div className="d-flex justify-content-center">
        <div style={{ width: "300px" }}>
          <input
            type="text"
            className="form-control"
            placeholder="Buscar CTO"
            value={searchCTO}
            onChange={(e) => handleSearch(e.target.value)}
          />

          {searchResults.length > 0 && (
            <div
              style={{
                position: "absolute",
                top: "18%",
                width: "16%",
                background: "#fff",
                border: "1px solid #ccc",
                borderRadius: "6px",
                maxHeight: "200px",
                overflowY: "auto",
                zIndex: 999
              }}
            >
              {searchResults.map((cto) => (
                <div
                  key={cto.id}
                  style={{
                    padding: "8px",
                    cursor: "pointer",
                    borderBottom: "1px solid #eee"
                  }}
                  onClick={() => flyToCTO(cto)}
                >
                  {cto.nome}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="d-flex justify-content-center mt-2">
        <div style={{ width: "300px", display: "flex", gap: "5px" }}>
          <input
            type="text"
            className="form-control"
            value={coordInput}
            onChange={(e) => setCoordInput(e.target.value)}
          />
          <button className="btn btn-primary" onClick={handleGoToCoord}>
            Ir
          </button>
        </div>
      </div>

      <div className="container-fluid p-1 m-1">
        {/* Inputs de cadastro da CTO */}
        {!isReadOnly && (
          <div className="row align-items-end g-0 bg-white p-0 rounded shadow-sm mb-0 justify-content-center">
            <div className="col-md-3">
              <label className="form-label fw-bold">Nome da CTO</label>
              <input
                type="text"
                className="form-control"
                placeholder="Ex: CTO-01"
                value={tempName}
                onChange={(e) => setTempName(e.target.value)}
              />
            </div>

            <div className="col-md-2">
              <label className="form-label fw-bold">Sinal (dBm)</label>
              <input
                type="number"
                step="0.01"
                className="form-control"
                placeholder="-24.20"
                value={tempSignal}
                onChange={(e) => setTempSignal(e.target.value)}
              />
            </div>

            <div className="col-md-2">
              <label className="form-label fw-bold">Splitter</label>
              <input
                type="number"
                className="form-control"
                placeholder="Ex: 16"
                value={tempSplitter}
                onChange={(e) => setTempSplitter(e.target.value)}
              />
            </div>

            <div className="col-md-2 d-grid">
              <button className="btn btn-primary fw-semibold" onClick={saveCTO}>
                Cadastrar CTO
              </button>
            </div>
            <div className="col-md-2 d-grid">
              <input
                type="file"
                accept=".kmz,.kml"
                className="form-control"
                onChange={handleKMZUpload}
              />
            </div>
          </div>
        )}
        {selectedCoord && (
          <p className="small text-muted text-center">
            📍 Coordenadas: {selectedCoord.lat}, {selectedCoord.lon}
          </p>
        )}
        
        {/* Mapa */}
        <div
          ref={mapContainer}
          className="mt-1 rounded shadow"
          style={{ width: "100%", height: "85vh" }}
        />
      </div>

      {/* LEGENDA FIXA NO MAPA */}
      <div
        style={{
          position: "fixed",
          bottom: 20,
          right: 10,
          zIndex: 1000,
          background: "rgba(0,0,0,0.85)",
          borderRadius: "8px",
          color: "#fff",
          width: legendCollapsed ? "auto" : "clamp(220px, 20vw, 300px)",
          maxHeight: legendCollapsed ? "auto" : "40vh",
          fontSize: "clamp(11px, 1.2vw, 13px)",
          boxShadow: "0 2px 10px rgba(0,0,0,0.4)",
          transition: "width 0.2s ease, max-height 0.2s ease",
        }}
      >
        {/* Cabeçalho sempre visível */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "6px 10px",
            cursor: "pointer",
            borderBottom: legendCollapsed ? "none" : "1px solid rgba(255,255,255,0.15)",
          }}
          onClick={() => setLegendCollapsed(!legendCollapsed)}
        >
          <strong style={{ fontSize: "clamp(11px, 1.2vw, 13px)" }}>
            🚗 Condutores {!legendCollapsed && `(${legend.length})`}
          </strong>
          <span style={{ fontSize: 16, lineHeight: 1, marginLeft: 8 }}>
            {legendCollapsed ? "▲" : "▼"}
          </span>
        </div>

        {/* Conteúdo colapsável */}
        {!legendCollapsed && (
          <div
            style={{
              padding: "8px 10px",
              overflowY: "auto",
              maxHeight: "calc(40vh - 36px)",
            }}
          >
            {/* Cabeçalho das colunas */}
            {legend.length > 0 && (
              <div style={{ display: "flex", gap: 4, marginBottom: 4 }}>
                <div style={{ flex: 1, fontWeight: "bold", fontSize: "0.85em", opacity: 0.7 }}>Placa</div>
                <div style={{ flex: 1, fontWeight: "bold", fontSize: "0.85em", opacity: 0.7 }}>Condutor</div>
                <div style={{ width: 26 }} />
              </div>
            )}

            {/* Linhas salvas */}
            {legend.map((item, index) => (
              <div key={item.id} style={{ display: "flex", gap: 4, marginBottom: 4 }}>
                <input
                  value={item.placa}
                  onChange={(e) => updateLegendItem(index, "placa", e.target.value)}
                  onBlur={() => saveLegendItem(index)}
                  placeholder="ABC-1234"
                  className="form-control form-control-sm"
                  style={{ flex: 1, fontSize: "0.85em", padding: "2px 4px" }}
                />
                <input
                  value={item.condutor}
                  onChange={(e) => updateLegendItem(index, "condutor", e.target.value)}
                  onBlur={() => saveLegendItem(index)}
                  placeholder="Motorista"
                  className="form-control form-control-sm"
                  style={{ flex: 1, fontSize: "0.85em", padding: "2px 4px" }}
                />
                <button
                  onClick={() => removeLegendItem(index)}
                  className="btn btn-sm btn-danger"
                  style={{ padding: "2px 6px", fontSize: "0.8em" }}
                >
                  ✕
                </button>
              </div>
            ))}

            {/* Inputs para novo condutor */}
            <div style={{ display: "flex", gap: 4, marginTop: 6, borderTop: "1px solid rgba(255,255,255,0.15)", paddingTop: 6 }}>
              <input
                value={newPlaca}
                onChange={(e) => setNewPlaca(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && addLegendItem()}
                placeholder="Placa"
                className="form-control form-control-sm"
                style={{ flex: 1, fontSize: "0.85em", padding: "2px 4px" }}
              />
              <input
                value={newCondutor}
                onChange={(e) => setNewCondutor(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && addLegendItem()}
                placeholder="Condutor"
                className="form-control form-control-sm"
                style={{ flex: 1, fontSize: "0.85em", padding: "2px 4px" }}
              />
              <button
                onClick={addLegendItem}
                className="btn btn-sm btn-light"
                style={{ padding: "2px 8px", fontSize: "0.85em" }}
              >
                +
              </button>
            </div>
          </div>
        )}
      </div>
      {/* FIM LEGENDA */}
      {/* Modal */}
      {showModal && editData && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: 20,
              borderRadius: 8,
              minWidth: 400,
              maxHeight: "90%",
              position: "relative",
              overflowY: "auto",
            }}
          >
            {/* Botão X para fechar */}
            <button
              onClick={() => setShowModal(false)}
              style={{
                position: "absolute",
                top: 10,
                right: 10,
                background: "transparent",
                border: "none",
                fontSize: "22px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              X
            </button>

            <h3 className="text-center">
              {isReadOnly ? "Detalhes da CTO" : "Editar CTO"}
            </h3>

            <div className="fw-bold">
              Nome:
              <br />
              <input
                type="text"
                className="form-control"
                value={editData.name}
                onChange={(e) =>
                  setEditData({ ...editData, name: e.target.value })
                }
                disabled={isReadOnly}
                style={{ width: "100%", marginBottom: 10 }}
              />
            </div>

            <div className="fw-bold">
              Sinal (dBm):
              <br />
              <input
                type="number"
                className="form-control"
                step="0.01"
                value={editData.signal ?? ""}
                onChange={(e) =>
                  setEditData({ ...editData, signal: e.target.value })
                }
                disabled={isReadOnly}
                style={{ width: "100%", marginBottom: 10 }}
              />
            </div>

            <div className="fw-bold">
              OLT:
              <br />
              <input
                type="text"
                className="form-control"
                value={editData.olt || ""}
                onChange={(e) =>
                  setEditData({ ...editData, olt: e.target.value })
                }
                disabled={isReadOnly}
                style={{ width: "100%", marginBottom: 10 }}
              />
            </div>

            <div className="fw-bold">
              ID da OLT:
              <br />
              <input
                type="number"
                className="form-control"
                value={editData.id_olt || ""}
                onChange={(e) =>
                  setEditData({ ...editData, id_olt: e.target.value })
                }
                disabled={isReadOnly}
                style={{ width: "100%", marginBottom: 10 }}
              />
            </div>

            <div className="fw-bold">
              Lotação:
              <br />
              <input
                type="number"
                className="form-control"
                value={editData.lotacao ?? ""}
                onChange={(e) =>
                  setEditData({ ...editData, lotacao: e.target.value })
                }
                disabled={isReadOnly}
                style={{ width: "100%", marginBottom: 10 }}
              />
            </div>

            <div className="fw-bold">
              Splitter:
              <br />
              <input
                type="number"
                className="form-control"
                value={editData.splitter || ""}
                onChange={(e) =>
                  setEditData({ ...editData, splitter: e.target.value })
                }
                disabled={isReadOnly}
                style={{ width: "100%", marginBottom: 10 }}
              />
            </div>

            <div style={{ marginBottom: 20 }}>
              <h4 className="fw-bold">Clientes</h4>
              {clientes.map((cliente) => (
                <div
                  key={cliente.id}
                  style={{ display: "flex", gap: 5, marginBottom: 5 }}
                >
                  <input
                    type="text"
                    className="form-control"
                    value={cliente.nome}
                    disabled={isReadOnly}
                    onChange={(e) =>
                      setClientes(
                        clientes.map((c) =>
                          c.id === cliente.id ? { ...c, nome: e.target.value } : c
                        )
                      )
                    }
                    style={{ flex: 1 }}
                  />
                  <input
                    type="number"
                    className="form-control"
                    step="0.01"
                    value={cliente.sinal || ""}
                    disabled={isReadOnly}
                    onChange={(e) =>
                      setClientes(
                        clientes.map((c) =>
                          c.id === cliente.id ? { ...c, sinal: e.target.value } : c
                        )
                      )
                    }
                    style={{ width: 80 }}
                  />
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Login ID"
                    value={cliente.login_id || ""}
                    disabled={isReadOnly}
                    onChange={(e) =>
                      setClientes(
                        clientes.map((c) =>
                          c.id === cliente.id
                            ? { ...c, login_id: e.target.value }
                            : c
                        )
                      )
                    }
                    style={{ width: 90 }}
                  />
                  <input
                    type="text"
                    className="form-control"
                    placeholder="MAC"
                    value={cliente.mac || ""}
                    disabled={isReadOnly}
                    onChange={(e) =>
                      setClientes(
                        clientes.map((c) =>
                          c.id === cliente.id ? { ...c, mac: e.target.value } : c
                        )
                      )
                    }
                    style={{ width: 110 }}
                  />
                  <input
                    type="number"
                    className="form-control"
                    placeholder="ID ONT"
                    value={cliente.id_ont || ""}
                    disabled={isReadOnly}
                    onChange={(e) =>
                      setClientes(
                        clientes.map((c) =>
                          c.id === cliente.id
                            ? { ...c, id_ont: e.target.value }
                            : c
                        )
                      )
                    }
                    style={{ width: 90 }}
                  />
                  <input
                    type="text"
                    className="form-control"
                    placeholder="PON EX 0/1/2"
                    value={cliente.placa_pon || ""}
                    disabled={isReadOnly}
                    onChange={(e) =>
                      setClientes(
                        clientes.map((c) =>
                          c.id === cliente.id
                            ? { ...c, placa_pon: e.target.value }
                            : c
                        )
                      )
                    }
                    style={{ width: 90 }}
                  />
                  {!isReadOnly && (
                    <>
                      <button
                        onClick={() =>
                          updateCliente(clientes.find((c) => c.id === cliente.id))
                        }
                        className="btn btn-success"
                      >
                        Salvar
                      </button>
                      <button
                        onClick={() => deleteCliente(cliente.id)}
                        style={{ background: "#c00", color: "#fff" }}
                        className="btn btn-danger"
                      >
                        Excluir
                      </button>
                    </>
                  )}
                </div>
              ))}

              {!isReadOnly && (
                <div style={{ display: "flex", gap: 5, marginTop: 10 }}>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Novo cliente"
                    value={newClienteName}
                    onChange={(e) => setNewClienteName(e.target.value)}
                    style={{ flex: 1 }}
                  />
                  <input
                    type="number"
                    className="form-control"
                    step="0.01"
                    placeholder="Sinal"
                    value={newClienteSignal}
                    onChange={(e) => setNewClienteSignal(e.target.value)}
                    style={{ width: 80 }}
                  />
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Login ID"
                    value={newClienteLoginId}
                    onChange={(e) => setNewClienteLoginId(e.target.value)}
                    style={{ width: 90 }}
                  />
                  <input
                    type="text"
                    className="form-control"
                    placeholder="MAC"
                    value={newClienteMac || ""}
                    onChange={(e) => setNewClienteMac(e.target.value)}
                    style={{ width: 110 }}
                  />
                  <input
                    type="number"
                    className="form-control"
                    placeholder="ID ONT"
                    value={newClienteIdOnt || ""}
                    onChange={(e) => setNewClienteIdOnt(e.target.value)}
                    style={{ width: 90 }}
                  />
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Placa PON"
                    value={newClientePlacaPon || ""}
                    onChange={(e) => setNewClientePlacaPon(e.target.value)}
                    style={{ width: 90 }}
                  />
                  <button onClick={addCliente} className="btn btn-success">
                    Adicionar
                  </button>
                </div>
              )}
            </div>

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              {!isReadOnly && (
                <>
                  <button
                    onClick={updateCTO}
                    style={{ padding: 8 }}
                    className="btn btn-success"
                  >
                    Salvar CTO
                  </button>
                  <button
                    onClick={deleteCTO}
                    style={{ padding: 8, background: "#c00", color: "#fff" }}
                    className="btn btn-danger"
                  >
                    Excluir CTO
                  </button>
                  <button
                    onClick={() => setShowModal(false)}
                    style={{ padding: 8 }}
                    className="btn btn-dark"
                  >
                    Fechar
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
